import {toGetParams} from './form';
import {d7Order}     from './tracking';

/**
 * @typedef {{
 *  EMfirstNameField: string,
 *  EMlastNameField: string,
 *  EMemailField: string,
 *  EMtelephoneField: string,
 *  EMcompanyField: string,
 *
 *  EMpermissionIpfield: string,
 *  EMpermissionDateField: string,
 *
 *  EMfairVoucherField: string,
 *
 *  EMretailerField: string,
 *
 *  EMeventIdField: string,
 *  EMeventPartnerField: string,
 *  EMeventDateTimeField: string,
 *  EMeventAddressField: string,
 *  EMeventZipCodeField: string,
 *  EMeventCityField: string,
 *
 *  EMPredefined: Object,
 *
 *  EMEvents: EMEvent[],
 *  EMEventHashTags: string[],
 * }} EMData
 */

/**
 * @typedef {{
 *  Address: string,
 *  City: string,
 *  DateTime: string,
 *  Id: string,
 *  Partner: string,
 *  ZipCode: string,
 * }} EMEvent
 */

export function emSend(params, callBack) {
  const url = `https://app.emarketeer.com/ext/form/receiver.php?${toGetParams(params)}`;

  const $iframe = $('<iframe style="display: none" />');
  $iframe.appendTo('body');
  $iframe.attr('src', url);

  // Done submit
  setTimeout(() => {
    $iframe.remove();

    callBack();

    // Push code
    d7Order();
  }, 5000);
}
